import { Persona, PersonaPresence, PersonaSize, TooltipHost } from '@fluentui/react';
import { TrashCanIcon } from '@fluentui/react-northstar';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';
import "react-multi-carousel/lib/styles.css";
import { HubFile } from '../../model';
import defaultImage from '../../static/media/logo.png';
import { getFileColor } from '../../utils';
import styles from './index.module.scss';


const HubShare = ({
    emails,
    files,
    onRemoveClick,
    subject,
    message,
    subjectError,
    messageError,
    onMessageChange,
    onSubjectChange,
    isMobile,
    isPersonal}: {
        emails: {
            email: string,
            name: string,
            status: string
        }[],
        subject: string,
        message: string,
        files: HubFile[],
        onRemoveClick: (fileId: number) => void,
        onSubjectChange: (subject: string) => void,
        onMessageChange: (message: string) => void,
        subjectError?: string;
        messageError?: string;
        isMobile?: boolean;
        isPersonal?:boolean
    }) => {
    const stackTokens: Partial<IStackTokens> = { childrenGap: 10 };
    const subStackTokens: Partial<IStackTokens> = { childrenGap: 5 };

    const extractInitials = (inputName: string) => {
        let name = inputName.split(' ');
        let initials = name[0][0];
        if (name.length > 1) {
            initials = initials + name[1][0];
        }
        else {
            if (name[0].length > 2) {
                initials = initials + name[0][1];
            }
        }
        initials = initials.toUpperCase();
        return initials;
    }

    const [calloutExtraName, setCalloutExtraName] = React.useState<string[]>([]);


    const onHoverExtra = (e: any, remaining: any[]) => {
        let newRem = remaining.slice(4, remaining.length);
        let name: string[] = [];
        newRem.forEach((atten) => { name.push(atten.name) });
        setCalloutExtraName(name)
    }

    const renderFiles = (files: any) => (
        <Stack tokens={subStackTokens}>
            {files.map((file: any) =>
                <Stack.Item>
                    <Stack key={file.id} horizontal gap={8} className={styles.filesWrapper}>
                        <Stack.Item>
                            <img
                                className={styles.fileImage}
                                onError={(e) => { e.currentTarget.src = defaultImage; }}
                                src={file.thumbnail || defaultImage}
                                alt={file.description}
                            />
                        </Stack.Item>
                        <Stack.Item grow={1}>
                            <Stack>
                                <Stack.Item>
                                    <div>{file.description}</div>
                                </Stack.Item>
                                <Stack.Item>
                                    <div style={{ background: getFileColor(file.category) }} className={styles.fileBadge}>{file.category}</div>
                                </Stack.Item>
                            </Stack>
                        </Stack.Item>
                        <Stack.Item>
                            <TrashCanIcon className={styles.trash} outline onClick={() => onRemoveClick && onRemoveClick(file.id)} />
                        </Stack.Item>
                    </Stack>
                </Stack.Item>
            )}
        </Stack>
    );
    return (
        <Stack className={styles.shareWrapper} tokens={stackTokens}>
            {isMobile && <Stack horizontal={true}>
                <Label className={styles.toLabel} htmlFor="To">To : </Label>
                {emails.slice(0,4).map((item) => {
                    return <TooltipHost content={item.name} key={item.name}>
                        <Persona
                            key={item.email}
                            imageInitials={extractInitials(item.name)}
                            size={PersonaSize.size32}
                            presence={PersonaPresence.none}
                            hidePersonaDetails={false}
                            imageAlt="" /></TooltipHost>
                })}
                {emails.length > 4 &&
                    <TooltipHost content={calloutExtraName.join()} key={"ktool1"}><Persona
                        onMouseEnter={(e) => { onHoverExtra(e.currentTarget, emails) }}
                        key={'123'}
                        imageInitials={'+' + (emails.length - 4).toString()}
                        size={PersonaSize.size32}
                        presence={PersonaPresence.none}
                        hidePersonaDetails={true}
                    /></TooltipHost>
                }
            </Stack>}
            {!isMobile && <Stack.Item>
                <Label htmlFor="To">To :</Label>
                <div className={styles.emailContainer}>{emails.map((item) => <div key={item.email} className={styles.email}>{item.email}</div>)}</div>
            </Stack.Item>}
            <Stack.Item>
                <Label htmlFor="Message">Message :</Label>
                <TextField
                    multiline
                    resizable={false}
                    autoAdjustHeight={false}
                    className={styles.inputField}
                    placeholder="Add a message"
                    id="Message"
                    errorMessage={messageError}
                    onChange={(_, value) => { onMessageChange(value as string) }}
                    value={message}
                />
            </Stack.Item>
            <Stack.Item className={styles.file}>
                Files ({files.length})
      </Stack.Item>
            <Stack.Item grow={1} className={isPersonal ? styles.personalFilecontainer : styles.filecontainer}>
                {renderFiles(files)}
            </Stack.Item>
        </Stack>
    );
};

export default HubShare;
